import ReactGA from 'react-ga';

const ENABLED = (import.meta.env.VITE_GOOGLE_ANALYTICS_ENABLE || "").toLowerCase() === "true";
const ACCOUNT_ID = import.meta.env.VITE_GOOGLE_ANANLYTICS_ACCOUNT_ID;

if (ENABLED) {
  ReactGA.initialize(ACCOUNT_ID, {
    debug: false,
    titleCase: false
  });
}

export function pageView(location) {
  if (ENABLED) {
    ReactGA.pageview(location.pathname + location.search);
  }
}

export function modalView(modal) {
  if (ENABLED) {
    ReactGA.modalview(modal);
  }
}

export function event(catagory, action, label) {
  if (ENABLED) {
    ReactGA.event({catagory, action, label});
  }
}
